// store/reducers/syntheticImagesReducer.tsx

// Define the state shape
interface SyntheticImageData {
    file_url: string;
    part_id: string;
    _id: string;
  }
  
  interface SyntheticImagesState {
    imageData: SyntheticImageData[];
  }
  
  // Initial state
  const initialState: SyntheticImagesState = {
    imageData: [],
  };
  
  // Reducer
  const syntheticImagesReducer = (state = initialState, action: any): SyntheticImagesState => {
    switch (action.type) {
      case "SET_SYNTHETIC_IMAGE_URLS":
        return {
          ...state,
          imageData: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default syntheticImagesReducer;